module.exports = __webpack_public_path__ + "static/amy-5843921317ef25519c714c81a606ef61.m4a";